export enum AlertSeverity {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export enum AlertType {
  Toast = 'toast',
  Modal = 'modal',
  FullScreen = 'full-screen',
}

export interface ToastAlertMessage {
  id: string;
  title: string;
  body?: string;
  severity: AlertSeverity;
  type: AlertType.Toast;
  autoCloseInMs?: number;
}

export interface ModalAlertMessage {
  id: string;
  title: string;
  body?: string;
  btnTxt: string;
  icon?: string;
  btnAction: () => void;
  severity: AlertSeverity;
  type: AlertType.Modal;
  priority?: number;
}

export interface FullScreenAlertMessage {
  id: string;
  title: string;
  body?: string;
  btnTxt: string;
  btnAction: () => void;
  icon: string;
  severity: AlertSeverity;
  type: AlertType.FullScreen;
  priority?: number;
}

export type AlertMessage = ToastAlertMessage | ModalAlertMessage | FullScreenAlertMessage;
